import * as React from 'react';
import ContentBox from './ContentBox';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import CampaignTranslationListSingle from './CampaignTranslationListSingle';

export default function CampaignTranslationList(props) {
  return (
    <TableContainer>
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell sx={{width: '40%', paddingRight: 0}}><Typography variant="body1">Language</Typography></TableCell>
                    <TableCell sx={{width: '25%', paddingRight: 0}}><Typography variant="body1">Territory</Typography></TableCell>
                    <TableCell sx={{width: '25%', paddingRight: 0}}><Typography variant="body1">Code</Typography></TableCell>
                    <TableCell sx={{width: '10%', paddingRight: 0}}></TableCell>
                </TableRow>
            </TableHead>
        </Table>
        <ContentBox sx={{p: 0}}>
            <Table>
                <TableBody>
                    { ( props.data.length > 0 ) ?
                        props.data.map((row) => {
                            let translationSingleProps = {
                                key: row.getId(),
                                data: row
                            };

                            if( props.onDelete )
                            {
                                translationSingleProps['onDelete'] = props.onDelete;
                            }

                            return <CampaignTranslationListSingle {...translationSingleProps}/>
                        })
                    :
                    <TableRow>
                        <TableCell colSpan={7} sx={{width: '40%', paddingRight: 0, textAlign: 'center'}} component="th" scope="row">
                            <Typography variant="body1">No results to display</Typography>
                        </TableCell>
                    </TableRow>
                    }
                </TableBody>
            </Table>
        </ContentBox>
    </TableContainer>
  );
}